import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { filter, map, Observable } from 'rxjs';
import { Target } from 'src/interfaces/pratica';
import { IKpi } from '../requests/models/kpi-model';
import { KpiFactory } from '../requests/models/kpi-factory';
import { IconService } from '../_core/services/icon.service';
import { PraticaProgressService } from '../_core/services/pratica-progress.service';
import { ProductService } from '../_core/services/product.service';
import { LabelPipeModule } from '../_shared/label-pipe/label-pipe.module';
import { SharedModule } from '../_shared/shared.module';
import { PraticaTitleComponent } from '../_widgets/pratica-title/pratica-title.component';

type ScoreColor = 'Giallo' | 'Rosso' | 'Verde' | 'Arancione';

@Component({
  standalone: true,
  selector: 'app-score-summary',
  templateUrl: './score-summary.component.html',
  styleUrls: ['./score-summary.component.scss'],
  imports: [SharedModule, PraticaTitleComponent, LabelPipeModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ScoreSummaryComponent {
  creditScoreColor: ScoreColor | undefined = undefined;

  analisiAndamentaleColor: ScoreColor | undefined = undefined;

  kycColor: ScoreColor | undefined = undefined;

  constructor(
    public praticaProgressService: PraticaProgressService,
    public productService: ProductService,
    private iconService: IconService
  ) {
    iconService.getIcons(['businesses', 'professionals']);
  }

  get logo() {
    return this.praticaProgressService.selectedPratica$.pipe(
      filter((praticaData) => praticaData.state === 'completed'),
      map((praticaData) =>
        praticaData.data?.target === Target.IMPRESE
          ? 'businesses'
          : 'professionals'
      )
    );
  }

  get kpi(): Observable<Partial<IKpi> | null | undefined> {
    return this.productService.analisiCreditoProduct$.pipe(
      map((prod) => ({
        ...prod?.kpi,
        Fascia:
          prod?.kpi?.Fascia && prod?.kpi.Fascia.length === 1
            ? prod?.kpi.Fascia
            : 'N/A',
        Score: KpiFactory.roundNumbers(prod?.kpi?.Score),
        Costo_Garanzia: prod?.kpi?.Costo_Garanzia,
      }))
    );
  }

  get moduli$() {
    return this.productService.analisiCreditoProduct$.pipe(
      map((prod) => {
        let scoreInfo = KpiFactory.getScoreInfo(prod?.kpi);
        return scoreInfo;
      })
    );
  }
}
